import { useState, useEffect } from "react";
// import { saasDb, saasAuth } from "./saasAppConfig";
// import { signInWithEmailAndPassword } from "firebase/auth";
// import { collection, query, where, orderBy, getDocs } from "firebase/firestore";

// SECURITY FIX (see Security & Launch-Readiness Audit, Finding 6):
// this screen used to sign into the saas-app as admin@adyantam.in —
// a shared password read from a REACT_APP_ variable, meaning it
// shipped inside the public browser bundle. Replaced below with a
// staff-gated Cloud Function that can only ever read this one
// collection. Left here, commented, only as historical reference.
// const ADMIN_EMAIL = "admin@adyantam.in";
// const ADMIN_PASSWORD = process.env.REACT_APP_SAAS_ADMIN_PASSWORD;

import { getFunctions, httpsCallable } from "firebase/functions";
import app from "../firebase/config"; // abc-dashboard's own Firebase app instance (default export)

const functions = getFunctions(app, "asia-south1");
const listAppFeedbackFn = httpsCallable(functions, "listAppFeedback");

export default function AppFeedbackScreen() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        // The old sign-in block and direct getDocs(query(...)) call are
        // commented out below — replaced by a single call to the
        // staff-gated Cloud Function.
        //
        // if (!saasAuth.currentUser) {
        //   await signInWithEmailAndPassword(saasAuth, ADMIN_EMAIL, ADMIN_PASSWORD);
        // }
        // const snap = await getDocs(
        //   query(
        //     collection(saasDb, "feedback"),
        //     where("category", "==", "app"),
        //     orderBy("submittedAt", "desc")
        //   )
        // );
        // setItems(snap.docs.map((d) => ({ id: d.id, ...d.data() })));

        const result = await listAppFeedbackFn();
        setItems(result.data.items);
      } catch (e) {
        console.error("Fetch app feedback failed:", e);
        setErr("Couldn't load feedback. Please contact the developer — admin access may need to be reconfigured.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <div style={{ color: "#aab2c5", padding: "24px" }}>Loading…</div>;
  if (err) {
    return <div style={{ color: "#ff5252", padding: "24px" }}>{err}</div>;
  }
  if (items.length === 0) return <div style={{ color: "#aab2c5", padding: "24px" }}>No app feedback yet.</div>;

  return (
    <div style={{ padding: "24px", display: "flex", flexDirection: "column", gap: "12px" }}>
      {items.map((f) => (
        <div key={f.id} style={{
          background: "#1a1a24", border: "1px solid #2d2d3a", borderRadius: "10px", padding: "14px",
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", color: "#fff", fontSize: "13px" }}>
            <span>{"★".repeat(f.rating || 0)}{"☆".repeat(5 - (f.rating || 0))}</span>
            <span style={{ color: "#555570" }}>{f.appVersion} · {f.deviceInfo}</span>
          </div>
          {f.comment && (
            <div style={{ color: "#c8c8e0", fontSize: "13px", marginTop: "8px" }}>{f.comment}</div>
          )}
          <div style={{ color: "#555570", fontSize: "11px", marginTop: "8px" }}>
            {f.userName} · {f.mobile} · {f.screen}
          </div>
        </div>
      ))}
    </div>
  );
}